import type { ReactNode } from 'react';
import { Lightbulb, X } from 'lucide-react';

/** Small inline hint shown right where a feature would help. Keep the text to one sentence. */
export default function ContextTip({ children, action, onDismiss }: {
  children: ReactNode;
  action?: { label: string; onClick: () => void };
  onDismiss: () => void;
}) {
  return (
    <div className="flex items-center gap-2 rounded-md border border-warning/30 bg-warning/5 px-3 py-2 text-xs text-foreground/90">
      <Lightbulb className="w-3.5 h-3.5 shrink-0 text-warning" />
      <span className="flex-1 min-w-0">{children}</span>
      {action && (
        <button type="button" onClick={action.onClick} className="shrink-0 font-medium text-primary hover:underline">
          {action.label}
        </button>
      )}
      <button type="button" onClick={onDismiss} className="shrink-0 p-0.5 rounded text-muted-foreground hover:text-foreground hover:bg-muted" title="Don't show this tip again">
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
